import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../../core/services/api.service';
import {
	IDesignCreatePayload,
	IDesignDetailResponse,
	IDesignListResponse,
	IDesignUpdatePayload,
} from '../models/design.models';

@Injectable({
	providedIn: 'root',
})
export class DesignService extends ApiService {
	// TODO: Tipar
	public list(body: any): Observable<IDesignListResponse> {
		return this.http.post<IDesignListResponse>(environment.apiUrl + `/design-configs`, body, {
			headers: this.getHeaders(),
		});
	}

	public detail(id: string): Observable<IDesignDetailResponse> {
		return this.http.get<IDesignDetailResponse>(environment.apiUrl + `/design-config/${id}`, {
			headers: this.getHeaders(),
		});
	}

	public create(formData: FormData): Observable<any> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<any>(environment.apiUrl + `/design-config`, formData, {
			headers: headers,
		});
	}

	public update(id: string, formData: FormData): Observable<any> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<any>(environment.apiUrl + `/design-config/${id}`, formData, {
			headers: headers,
		});
	}

	// TODO: Tipar
	public delete(id: string): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/design-config/${id}`, {
			headers: this.getHeaders(),
		});
	}
}
